LS.getAmountToScroll = function (naturalWidth, availableWidth, gutter) {
    var amountToScroll = naturalWidth - availableWidth;
    if ($(window).outerWidth() < LS.tabletBreakpoint) {
        // account for the extra gutter on the first item
        amountToScroll = amountToScroll + gutter;
    }
    return amountToScroll;
}
LS.getHandleAmountToScroll = function ($row, $handle) {
    return $row.closest('.product-family').find('.product-row-bar').outerWidth() - $handle.outerWidth();
};
LS.productRowInit = function (firstInit) {
    if (!$('.product-row').length) {
        return
    }

    // clear values
    $('.product-row-bar').remove();
    $('.product-row-wrap').removeAttr('style');

    $('.product-row').each(function () {
        var $this = $(this);
        var $items = $this.find('.item');
        var hiddenItems = $this.find('.hidden'); // .find().not() breaks things
        var $sampleItem = $items.first();
        var gutter = Number($sampleItem.css('padding-right').replace('px', ''));
        var itemWidth = $sampleItem.outerWidth();
        // figure out how wide this row would be
        var naturalWidth = itemWidth * ($items.length - hiddenItems.length);

        // remove one gutter value on tablet and up due to last child having it's padding removed
        if ($(window).outerWidth() >= LS.tabletBreakpoint) {
            naturalWidth = naturalWidth - gutter;
        }

        // visible area of the row
        var availableWidth = $this.outerWidth();

        // do we need to scroll?
        if (naturalWidth > availableWidth) {
            $this.data('natural-width', naturalWidth);
            $this.data('available-width', availableWidth);
            $this.data('gutter', gutter);
            // add our scrollbar
            $('<div class="product-row-bar"><div class="handle" style="width: ' + availableWidth / naturalWidth * 100 + '%"></div></div>').insertAfter($this.closest('.product-row-wrap'));
            // how many pixels are we hanging off the side
            var amountToScroll = LS.getAmountToScroll(naturalWidth, availableWidth, gutter);
            // how far does the handle need to move
            var $handle = $this.closest('.product-family').find('.handle');
            var handleAmountToScroll = LS.getHandleAmountToScroll($this, $handle);
            $this.on('scroll', function () {
                // dragging + auto-moving the bar conflicts
                if ($('body').hasClass('dragging')) return;
                // of the distance we need to scroll, how far have we gone?
                var percentScrolled = $this.scrollLeft() / amountToScroll;
                // apply this progress how far the handle should move
                var translateAmt = percentScrolled * handleAmountToScroll;
                $handle.css({
                    'left': translateAmt,
                    // transform performs better, but left get used by draggable
                    // 'transform': 'translate3d(' + translateAmt + 'px, 0, 0)'
                });
            });
            // set the cropping window's height to hide iOS scrollbar
            // 2021-03: seems this is no longer necessary for iOS. 
            // $this.imagesLoaded( function() {
            //   $this.closest('.product-row-wrap').height($this.outerHeight() - $this.css('padding-bottom').replace('px',''));
            // });
        }

        // set up row heading text
        if (firstInit) {
            var $optionsEl = $(this).closest('.product-family').find('.configuration-options');
            var options = [];
            var materials = [];
            var sizes = 1;
            $items.each(function () {
                var materialName = $(this).find('.material').text();
                var variantCount = $(this).find('.product-link').data('variant-count');
                if ($.inArray(materialName, materials) === -1) {
                    materials.push(materialName);
                }
                if (variantCount > sizes) {
                    sizes = variantCount;
                }
            });
            if (materials.length > 1) {
                options.push(materials.length + ' materials')
            }
            if (sizes > 1) {
                options.push(sizes + ' sizes')
            }
            if ($items.length > 1) {
                options.push($items.length + ' colors available');
            } else {
                options.push('1 color available');
            }
            $optionsEl.html('<a href="' + $sampleItem.find('.product-link').attr('href') + '">' + options.join(' / ') + ' &gt;</a>');
        }
    });
};

LS.draggableScrollbar = function () {
    $('.product-row-bar .handle').each(function () {
        $(this).draggable({
            axis: 'x',
            containment: 'parent',
            drag: function (event, ui) {
                $('body').addClass('dragging');
                let $handle = $(event.target);
                let $productRow = $handle.closest('.product-family').find('.product-row-wrap .product-row');
                var handleAmountToScroll = LS.getHandleAmountToScroll($productRow, $handle);
                var percentScrolled = ui.position.left / handleAmountToScroll;
                var amountToScroll = LS.getAmountToScroll($productRow.data('natural-width'), $productRow.data('available-width'), $productRow.data('gutter'));
                $productRow.scrollLeft(amountToScroll * percentScrolled);
                $handle.addClass('dragging');
            },
            stop: function (event, ui) {
                $(event.target).removeClass('dragging');
                $('body').removeClass('dragging');
            }
        });
    });
}

$(document).ready(function () {

    LS.productRowInit(true);
    $(window).resize(function () {
        LS.productRowInit(false);
        LS.draggableScrollbar();
    });

    $('.product-row-bar .handle').each(function () {
        $(this).draggable({
            axis: 'x',
            containment: 'parent',
            drag: function (event, ui) {
                $('body').addClass('dragging');
                let $handle = $(event.target);
                let $productRow = $handle.closest('.product-family').find('.product-row-wrap .product-row');
                var handleAmountToScroll = LS.getHandleAmountToScroll($productRow, $handle);
                var percentScrolled = ui.position.left / handleAmountToScroll;
                var amountToScroll = LS.getAmountToScroll($productRow.data('natural-width'), $productRow.data('available-width'), $productRow.data('gutter'));
                $productRow.scrollLeft(amountToScroll * percentScrolled);
                $handle.addClass('dragging');
            },
            stop: function (event, ui) {
                $(event.target).removeClass('dragging');
                $('body').removeClass('dragging');
            }
        });
    });
});
